/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { SeasonOrYear } from 'client-code/bookmarks';

import { BookmarkServiceRepositoryImpl } from '../impls/BookmarkServiceRepositoryImpl';
import { IBookmarkService } from '../interfaces/IBookmarkService';
import { IBookmarkServiceRepository } from '../interfaces/IBookmarkServiceRepository';
import { TiVoNetworkRequestModel } from '../tivo';
import { TServicesParams } from '../types';

export class BookmarkService implements IBookmarkService {
    private static TAG: string = 'BookmarkService';

    private mBookmarkServiceRepository: IBookmarkServiceRepository;

    public constructor(params: TServicesParams) {
        this.mBookmarkServiceRepository = new BookmarkServiceRepositoryImpl(params);
    }

    /**
     * @inheritdoc
     */
    public getRequestModelToCreateBookmarkContentIdSchedule(
        contentId: string,
        unifiedCollectionId: string,
    ): TiVoNetworkRequestModel<any> {
        const oRequestModel = new TiVoNetworkRequestModel(
            this.mBookmarkServiceRepository.createBookmarkContentIdSchedule.bind(
                this.mBookmarkServiceRepository,
            ),
        );
        oRequestModel.addRequestParams(contentId, unifiedCollectionId);
        return oRequestModel;
    }

    /**
     * @inheritdoc
     */
    public getRequestModelToCreateBookmarkCollectionIdSchedule(
        collectionId: string,
        seasonOrYear: SeasonOrYear,
    ): TiVoNetworkRequestModel<any> {
        const oRequestModel = new TiVoNetworkRequestModel(
            this.mBookmarkServiceRepository.createBookmarkCollectionIdSchedule.bind(
                this.mBookmarkServiceRepository,
            ),
        );
        oRequestModel.addRequestParams(collectionId, seasonOrYear);
        return oRequestModel;
    }

    /**
     * @inheritdoc
     */
    public getRequestModelToDeleteBookmarkSchedule(
        contentId: string,
    ): TiVoNetworkRequestModel<any> {
        const oRequestModel = new TiVoNetworkRequestModel(
            this.mBookmarkServiceRepository.deleteBookmarkContentIdSchedule.bind(
                this.mBookmarkServiceRepository,
            ),
        );
        oRequestModel.addRequestParams(contentId);
        return oRequestModel;
    }
}
